export const TABLE = "CONTRACT";
export const TABLE_CONTRACTS_DETAILS = "CONTRACTS_DETAILS";

export const STYLE_STATUS = {
  1: "bg-primary",
  2: "bg-success",
  3: "bg-danger",
  4: "bg-gray",
  5: "bg-orange",
};
export const STATUS_LIST = [
  { value: 1, name: "Mới tạo" },
  { value: 2, name: "Hợp đồng đã gia hạn" },
  { value: 3, name: "Hợp đồng hết hạn" },
  { value: 4, name: "Hợp đồng đã dừng theo dõi" },
  { value: 5, name: "Hợp đồng sắp hết hạn" },
];
export const TYPE_DATE = [
  { id: 1, name: "Ngày" },
  { id: 2, name: "Tháng" },
  { id: 3, name: "Năm" },
];

export const EXPIRE_DATE = [
  { id: 1, name: "1 tháng" },
  { id: 2, name: "2 tháng" },
  { id: 3, name: "3 tháng" },
  { id: 4, name: "4 tháng" },
  { id: 5, name: "5 tháng" },
  { id: 6, name: "6 tháng" },
];

export const VAT_LIST = [
  { value: 1, name: "Doanh nghiệp đầu tư (10%)" },
  { value: 2, name: "Doanh nghiệp chế xuất (0%)" },
];
